import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    CircularProgress,
} from '@mui/material'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import idDirectory from './idAttributes'
import './styles.scss'

export interface INewConfirmActionModalProps {
    open: boolean
    toggleOpen: () => void
    onConfirm: () => void
    testId: string
    header?: string
    message?: string
    cancelButtonText?: string
    confirmButtonText?: string
    inactivateConfirmButton?: boolean
    isLoadingConfirmButton?: boolean
    additionalContent?: React.ReactNode
    maxModalWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false
    enableConfirmActionModalSlim?: boolean
    className?: string
}

const NewConfirmActionModal = ({
    open,
    toggleOpen,
    onConfirm,
    header = 'Confirmation needed',
    message = 'Are you sure?',
    cancelButtonText = 'Cancel',
    confirmButtonText = 'Confirm',
    inactivateConfirmButton = false,
    isLoadingConfirmButton = false,
    testId = '',
    additionalContent = null,
    maxModalWidth = 'xs',
    enableConfirmActionModalSlim = false,
    className = '',
}: INewConfirmActionModalProps) => {
    const { clientTheme } = useThemeStyling()
    return (
        <Dialog
            fullWidth
            open={open}
            className={className}
            maxWidth={maxModalWidth}
            scroll={'body'}
            id={`${idDirectory.divRoot}-${testId}`}
        >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={'emp-newConfirmActionModal-modalClose'} onClick={toggleOpen}>
                <path d="M4.5 13.5L13.5 4.5M4.5 4.5L13.5 13.5" stroke="#8A9BA8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

            <div
                className={'emp-newConfirmActionModal-dialogHeaderContainer'}
                id={`${idDirectory.divHeader}-${testId}`}
            >
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '4px', marginLeft: '-4px' }}>
<path d="M18 3.375C15.1075 3.375 12.2799 4.23274 9.87479 5.83976C7.46972 7.44677 5.5952 9.73089 4.48827 12.4033C3.38134 15.0756 3.09171 18.0162 3.65602 20.8532C4.22033 23.6902 5.61323 26.2961 7.65857 28.3414C9.70391 30.3868 12.3098 31.7797 15.1468 32.344C17.9838 32.9083 20.9244 32.6187 23.5968 31.5117C26.2691 30.4048 28.5532 28.5303 30.1602 26.1252C31.7673 23.7201 32.625 20.8926 32.625 18C32.6209 14.1225 31.0788 10.4049 28.3369 7.66309C25.5951 4.92125 21.8775 3.37909 18 3.375ZM18 30.375C15.5525 30.375 13.1599 29.6492 11.1248 28.2894C9.08977 26.9297 7.50363 24.9969 6.567 22.7357C5.63036 20.4745 5.3853 17.9863 5.86279 15.5858C6.34028 13.1852 7.51889 10.9802 9.24956 9.24955C10.9802 7.51888 13.1852 6.34027 15.5858 5.86278C17.9863 5.38529 20.4745 5.63036 22.7357 6.56699C24.997 7.50363 26.9297 9.08976 28.2894 11.1248C29.6492 13.1599 30.375 15.5525 30.375 18C30.3713 21.2809 29.0663 24.4264 26.7463 26.7463C24.4264 29.0663 21.2809 30.3713 18 30.375ZM16.875 19.125V11.25C16.875 10.9516 16.9935 10.6655 17.2045 10.4545C17.4155 10.2435 17.7016 10.125 18 10.125C18.2984 10.125 18.5845 10.2435 18.7955 10.4545C19.0065 10.6655 19.125 10.9516 19.125 11.25V19.125C19.125 19.4234 19.0065 19.7095 18.7955 19.9205C18.5845 20.1315 18.2984 20.25 18 20.25C17.7016 20.25 17.4155 20.1315 17.2045 19.9205C16.9935 19.7095 16.875 19.4234 16.875 19.125ZM19.6875 24.1875C19.6875 24.5213 19.5885 24.8475 19.4031 25.125C19.2177 25.4025 18.9541 25.6188 18.6458 25.7465C18.3374 25.8743 17.9981 25.9077 17.6708 25.8426C17.3434 25.7775 17.0428 25.6167 16.8068 25.3807C16.5708 25.1447 16.41 24.8441 16.3449 24.5167C16.2798 24.1894 16.3132 23.8501 16.441 23.5417C16.5687 23.2334 16.785 22.9698 17.0625 22.7844C17.34 22.599 17.6663 22.5 18 22.5C18.4476 22.5 18.8768 22.6778 19.1932 22.9943C19.5097 23.3107 19.6875 23.7399 19.6875 24.1875Z" fill="#FF9500"/>
</svg>


                <div
                    className={
                        enableConfirmActionModalSlim
                            ? 'emp-newConfirmActionModal-dialogTitleSlim'
                            : 'emp-newConfirmActionModal-dialogTitle'
                    }
                >
                    {header}
                </div>
            </div>

            <DialogContent
                className={'emp-newConfirmActionModal-dialogContent'}
                id={`${idDirectory.divContent}-${testId}`}
            >
                <div
                    className={
                        enableConfirmActionModalSlim
                            ? 'emp-newConfirmActionModal-dialogContentTextSlim'
                            : 'emp-newConfirmActionModal-dialogContentText'
                    }
                >
                    {message}
                </div>

                {additionalContent && <div>{additionalContent}</div>}
            </DialogContent>

            <DialogActions
                className={'emp-newConfirmActionModal-dialogActions'}
                id={`${idDirectory.divActions}-${testId}`}
            >
                <Button
                    variant="contained"
                    onClick={toggleOpen}
                    id={`${idDirectory.btnCancel}-${testId}`}
                    sx={clientTheme.buttons.defaultButton.style}
                >
                    {cancelButtonText}
                </Button>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={onConfirm}
                    id={`${idDirectory.btnConfirm}-${testId}`}
                    disabled={inactivateConfirmButton}
                >
                    {isLoadingConfirmButton ? (
                        <>
                            Submitting...{' '}
                            <CircularProgress
                                className={'emp-newConfirmActionModal-circularProgress'}
                                color="secondary"
                            />
                        </>
                    ) : (
                        confirmButtonText
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default NewConfirmActionModal
